import { Checkbox, Text } from '@retailer-platform/shared-components/src/tds'
import { type NavMenuHierarchyL2 } from '../../nav-v2/NavMenuHierarchy'
import { useDashIntl } from '../../../../intl/intl.hooks'

interface PermissionCheckboxProps {
  tool: NavMenuHierarchyL2
  isChecked: boolean
  isDisabled: boolean
  onCheckboxChange: () => void
  readOnly?: boolean
}

export const PermissionCheckbox = ({
  tool,
  isChecked,
  isDisabled,
  onCheckboxChange,
  readOnly,
}: PermissionCheckboxProps) => {
  const dashIntl = useDashIntl()
  const i18nName = dashIntl.formatMessage({ id: tool.name as any })

  return (
    <>
      {readOnly ? (
        <Text typography="bodyEmphasized">{i18nName}</Text>
      ) : (
        <Checkbox
          label={i18nName}
          checked={isChecked}
          onChange={onCheckboxChange}
          disabled={isDisabled}
        />
      )}
    </>
  )
}
